import request from '@/utils/request'

export default function pageAgencyMerchants(pageNum, pageSize) {
  return request({
    url: `/chatGroup/agency/merchantPage/${pageNum}/${pageSize}`,
    method: 'get',
  })
}
